/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Component imports
import ChatSessionsTable from '../components/Tables/ChatSessionsTable';
import DocumentTitle from '../components/DocumentTitle';
import Permissioned from '../components/Permissioned';

// Misc imports
import useUserPermissions from '../utils/hooks/useUserPermissions';
import { PERMISSIONS_GROUP_VIEWER } from '../constants/main';

const ChatSessionsScreen = () => {
  const { orgId } = useParams();
  const { t } = useTranslation();
  const userPermissions = useUserPermissions(orgId);

  return (
    <Permissioned
      allowedPermissions={PERMISSIONS_GROUP_VIEWER}
      currentPermissions={userPermissions}
    >
      <DocumentTitle title={t('Chat Sessions')} />
      <ChatSessionsTable />
    </Permissioned>
  );
};

export default ChatSessionsScreen;
